// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Night Owl Theme for OpenSCAD Playground
   Based on Sarah Drasner's Night Owl VS Code theme
   https://github.com/sdras/night-owl-vscode-theme
*/

:root {
  /* Night Owl core palette */
  --night-owl-bg: #011627;
  --night-owl-bg-light: #021d34;
  --night-owl-bg-lighter: #032440;
  --night-owl-bg-hover: #082e4a;
  --night-owl-fg: #d6deeb;
  --night-owl-fg-muted: #637777;
  --night-owl-accent: #7e57c2;
  --night-owl-accent-bright: #c792ea;
  --night-owl-blue: #82aaff;
  --night-owl-cyan: #21c7d8;
  --night-owl-green: #c5e478;
  --night-owl-yellow: #ffcb8b;
  --night-owl-orange: #f78c6c;
  --night-owl-red: #ef5350;
  --night-owl-pink: #ee90bc;
  --night-owl-border: #1d3b53;
  --night-owl-selection: #1b3d5e;
  --night-owl-scrollbar: #1d3b53;
  --night-owl-scrollbar-hover: #2a4d6e;
}

/* ── Global body ── */
body {
  background-color: var(--night-owl-bg) !important;
  color: var(--night-owl-fg) !important;
}

/* ── Scrollbar ── */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: var(--night-owl-bg);
}
::-webkit-scrollbar-thumb {
  background: var(--night-owl-scrollbar);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--night-owl-scrollbar-hover);
}
::-webkit-scrollbar-corner {
  background: var(--night-owl-bg);
}

/* ── Panel switcher / tab bar ── */
.p-tabmenu,
.p-tabmenu .p-tabmenu-nav,
.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {
  background: var(--night-owl-bg-light) !important;
  color: var(--night-owl-fg) !important;
  border-color: var(--night-owl-border) !important;
}
.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
  color: var(--night-owl-cyan) !important;
  border-bottom-color: var(--night-owl-cyan) !important;
}
.p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):hover .p-menuitem-link {
  color: var(--night-owl-blue) !important;
  background: var(--night-owl-bg-hover) !important;
}

/* ── Toggle buttons (multi-layout panel toggles) ── */
.p-togglebutton {
  background: var(--night-owl-bg-lighter) !important;
  color: var(--night-owl-fg) !important;
  border-color: var(--night-owl-border) !important;
}
.p-togglebutton.p-highlight {
  background: var(--night-owl-accent) !important;
  color: #fff !important;
  border-color: var(--night-owl-accent) !important;
}
.p-togglebutton:hover {
  background: var(--night-owl-bg-hover) !important;
}

/* ── Buttons ── */
.p-button {
  background: var(--night-owl-accent) !important;
  border-color: var(--night-owl-accent) !important;
  color: #fff !important;
}
.p-button:hover {
  background: var(--night-owl-accent-bright) !important;
  border-color: var(--night-owl-accent-bright) !important;
}
.p-button.p-button-outlined {
  background: transparent !important;
  color: var(--night-owl-accent-bright) !important;
  border-color: var(--night-owl-accent) !important;
}
.p-button.p-button-text,
.p-button.p-button-link {
  background: transparent !important;
  color: var(--night-owl-fg) !important;
  border-color: transparent !important;
}
.p-button.p-button-text:hover,
.p-button.p-button-link:hover {
  background: var(--night-owl-bg-hover) !important;
  color: var(--night-owl-blue) !important;
}
.p-button.p-button-sm {
  font-size: 0.875rem;
}
.p-button.p-button-secondary {
  background: var(--night-owl-bg-lighter) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-button.p-button-secondary:hover {
  background: var(--night-owl-bg-hover) !important;
}
.p-button:disabled {
  opacity: 0.5 !important;
}

/* ── Severity buttons ── */
.p-button.p-button-danger {
  background: var(--night-owl-red) !important;
  border-color: var(--night-owl-red) !important;
}
.p-button.p-button-warning {
  background: var(--night-owl-orange) !important;
  border-color: var(--night-owl-orange) !important;
}
.p-button.p-button-success {
  background: var(--night-owl-green) !important;
  border-color: var(--night-owl-green) !important;
  color: var(--night-owl-bg) !important;
}
.p-button.p-button-info {
  background: var(--night-owl-blue) !important;
  border-color: var(--night-owl-blue) !important;
}

/* ── Progress bar ── */
.p-progressbar {
  background: var(--night-owl-bg-lighter) !important;
}
.p-progressbar .p-progressbar-value {
  background: var(--night-owl-cyan) !important;
}

/* ── Badge ── */
.p-badge.p-badge-danger {
  background: var(--night-owl-red) !important;
}
.p-badge.p-badge-warning {
  background: var(--night-owl-orange) !important;
}
.p-badge.p-badge-info {
  background: var(--night-owl-blue) !important;
}
.p-badge.p-badge-success {
  background: var(--night-owl-green) !important;
  color: var(--night-owl-bg) !important;
}

/* ── Editor panel ── */
.editor-panel {
  background: var(--night-owl-bg) !important;
}

/* ── File picker / breadcrumb ── */
.p-breadcrumb {
  background: var(--night-owl-bg-light) !important;
  border-color: var(--night-owl-border) !important;
}
.p-breadcrumb .p-breadcrumb-list li a,
.p-breadcrumb .p-menuitem-text {
  color: var(--night-owl-fg) !important;
}
.p-breadcrumb .p-breadcrumb-list li a:hover {
  color: var(--night-owl-cyan) !important;
}

/* ── Menu / overlay ── */
.p-menu {
  background: var(--night-owl-bg-light) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-menu .p-menuitem-link {
  color: var(--night-owl-fg) !important;
}
.p-menu .p-menuitem-link:hover {
  background: var(--night-owl-bg-hover) !important;
  color: var(--night-owl-cyan) !important;
}
.p-menu .p-menuitem-link .p-menuitem-icon {
  color: var(--night-owl-fg-muted) !important;
}
.p-menu .p-menuitem-link:hover .p-menuitem-icon {
  color: var(--night-owl-cyan) !important;
}
.p-menu .p-menuitem-link .p-menuitem-text {
  color: var(--night-owl-fg) !important;
}
.p-menu .p-menuitem-link:hover .p-menuitem-text {
  color: var(--night-owl-cyan) !important;
}

/* ── Overlay panel ── */
.p-overlaypanel {
  background: var(--night-owl-bg-light) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}

/* ── Confirm dialog ── */
.p-dialog,
.p-confirm-dialog {
  background: var(--night-owl-bg-light) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-dialog .p-dialog-header {
  color: var(--night-owl-fg) !important;
  background: var(--night-owl-bg-light) !important;
}
.p-dialog .p-dialog-footer {
  background: var(--night-owl-bg-lighter) !important;
  border-top-color: var(--night-owl-border) !important;
}

/* ── Toast ── */
.p-toast .p-toast-message {
  background: var(--night-owl-bg-lighter) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}

/* ── Dropdown / select ── */
.p-dropdown {
  background: var(--night-owl-bg-lighter) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-dropdown .p-dropdown-label {
  color: var(--night-owl-fg) !important;
}
.p-dropdown:not(.p-disabled):hover {
  border-color: var(--night-owl-cyan) !important;
}
.p-dropdown-panel {
  background: var(--night-owl-bg-light) !important;
  border-color: var(--night-owl-border) !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  color: var(--night-owl-fg) !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {
  background: var(--night-owl-bg-hover) !important;
  color: var(--night-owl-cyan) !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background: var(--night-owl-selection) !important;
  color: var(--night-owl-cyan) !important;
}

/* ── Checkbox / input ── */
.p-checkbox .p-checkbox-box {
  background: var(--night-owl-bg-lighter) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-checkbox .p-checkbox-box.p-highlight {
  background: var(--night-owl-accent) !important;
  border-color: var(--night-owl-accent) !important;
  color: #fff !important;
}
.p-inputtext {
  background: var(--night-owl-bg-lighter) !important;
  border-color: var(--night-owl-border) !important;
  color: var(--night-owl-fg) !important;
}
.p-inputtext:focus {
  border-color: var(--night-owl-cyan) !important;
  box-shadow: 0 0 0 0.2rem rgba(33, 199, 216, 0.25) !important;
}

/* ── Customizer panel ── */
.customizer-panel {
  background: var(--night-owl-bg) !important;
  color: var(--night-owl-fg) !important;
}

/* ── Log panel ── */
pre {
  color: var(--night-owl-fg) !important;
  background: transparent !important;
}

/* ── Tooltip ── */
.p-tooltip .p-tooltip-text {
  background: var(--night-owl-bg-lighter) !important;
  color: var(--night-owl-fg) !important;
  border: 1px solid var(--night-owl-border);
}
.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--night-owl-bg-lighter) !important;
}

/* ── Divider / separator ── */
.p-menu-separator {
  border-top-color: var(--night-owl-border) !important;
}

/* ── Link color ── */
a {
  color: var(--night-owl-cyan);
}
a:hover {
  color: var(--night-owl-blue);
}

/* ── Selection ── */
::selection {
  background: var(--night-owl-selection);
  color: var(--night-owl-fg);
}

/* ── Monaco editor overrides ── */
/* Only set the outer container; Monaco's internal elements are canvas/theme-driven */
.monaco-editor {
  background-color: #011627 !important;
}
`, "",{"version":3,"sources":["webpack://./src/night-owl.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;;;EAGE,gDAAgD;EAChD,qCAAqC;EACrC,gDAAgD;AAClD;AACA;EACE,uCAAuC;EACvC,qDAAqD;AACvD;AACA;EACE,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA,sDAAsD;AACtD;EACE,kDAAkD;EAClD,qCAAqC;EACrC,gDAAgD;AAClD;AACA;EACE,8CAA8C;EAC9C,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,qDAAqD;EACrD,uDAAuD;AACzD;AACA;EACE,kCAAkC;EAClC,gDAAgD;EAChD,gDAAgD;AAClD;AACA;;EAEE,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;AACtC;AACA;;EAEE,gDAAgD;EAChD,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;AACA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,qCAAqC;AACvC;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,kDAAkD;AACpD;AACA;EACE,4CAA4C;AAC9C;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;AAC7C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,gDAAgD;AAClD;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,gDAAgD;EAChD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gDAAgD;EAChD,uCAAuC;AACzC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,gDAAgD;EAChD,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;;EAEE,gDAAgD;EAChD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,gDAAgD;AAClD;AACA;EACE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA,gBAAgB;AAChB;EACE,kDAAkD;EAClD,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,kDAAkD;EAClD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;EAChD,gDAAgD;AAClD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gDAAgD;EAChD,uCAAuC;AACzC;AACA;EACE,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE,kDAAkD;EAClD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,8CAA8C;EAC9C,4DAA4D;AAC9D;;AAEA,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kDAAkD;EAClD,qCAAqC;EACrC,yCAAyC;AAC3C;AACA;EACE,wDAAwD;AAC1D;;AAEA,8BAA8B;AAC9B;EACE,oDAAoD;AACtD;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC,qFAAqF;AACrF;EACE,oCAAoC;AACtC","sourcesContent":["/* Night Owl Theme for OpenSCAD Playground\n   Based on Sarah Drasner's Night Owl VS Code theme\n   https://github.com/sdras/night-owl-vscode-theme\n*/\n\n:root {\n  /* Night Owl core palette */\n  --night-owl-bg: #011627;\n  --night-owl-bg-light: #021d34;\n  --night-owl-bg-lighter: #032440;\n  --night-owl-bg-hover: #082e4a;\n  --night-owl-fg: #d6deeb;\n  --night-owl-fg-muted: #637777;\n  --night-owl-accent: #7e57c2;\n  --night-owl-accent-bright: #c792ea;\n  --night-owl-blue: #82aaff;\n  --night-owl-cyan: #21c7d8;\n  --night-owl-green: #c5e478;\n  --night-owl-yellow: #ffcb8b;\n  --night-owl-orange: #f78c6c;\n  --night-owl-red: #ef5350;\n  --night-owl-pink: #ee90bc;\n  --night-owl-border: #1d3b53;\n  --night-owl-selection: #1b3d5e;\n  --night-owl-scrollbar: #1d3b53;\n  --night-owl-scrollbar-hover: #2a4d6e;\n}\n\n/* ── Global body ── */\nbody {\n  background-color: var(--night-owl-bg) !important;\n  color: var(--night-owl-fg) !important;\n}\n\n/* ── Scrollbar ── */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-track {\n  background: var(--night-owl-bg);\n}\n::-webkit-scrollbar-thumb {\n  background: var(--night-owl-scrollbar);\n  border-radius: 4px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: var(--night-owl-scrollbar-hover);\n}\n::-webkit-scrollbar-corner {\n  background: var(--night-owl-bg);\n}\n\n/* ── Panel switcher / tab bar ── */\n.p-tabmenu,\n.p-tabmenu .p-tabmenu-nav,\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link {\n  background: var(--night-owl-bg-light) !important;\n  color: var(--night-owl-fg) !important;\n  border-color: var(--night-owl-border) !important;\n}\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {\n  color: var(--night-owl-cyan) !important;\n  border-bottom-color: var(--night-owl-cyan) !important;\n}\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem:not(.p-highlight):hover .p-menuitem-link {\n  color: var(--night-owl-blue) !important;\n  background: var(--night-owl-bg-hover) !important;\n}\n\n/* ── Toggle buttons (multi-layout panel toggles) ── */\n.p-togglebutton {\n  background: var(--night-owl-bg-lighter) !important;\n  color: var(--night-owl-fg) !important;\n  border-color: var(--night-owl-border) !important;\n}\n.p-togglebutton.p-highlight {\n  background: var(--night-owl-accent) !important;\n  color: #fff !important;\n  border-color: var(--night-owl-accent) !important;\n}\n.p-togglebutton:hover {\n  background: var(--night-owl-bg-hover) !important;\n}\n\n/* ── Buttons ── */\n.p-button {\n  background: var(--night-owl-accent) !important;\n  border-color: var(--night-owl-accent) !important;\n  color: #fff !important;\n}\n.p-button:hover {\n  background: var(--night-owl-accent-bright) !important;\n  border-color: var(--night-owl-accent-bright) !important;\n}\n.p-button.p-button-outlined {\n  background: transparent !important;\n  color: var(--night-owl-accent-bright) !important;\n  border-color: var(--night-owl-accent) !important;\n}\n.p-button.p-button-text,\n.p-button.p-button-link {\n  background: transparent !important;\n  color: var(--night-owl-fg) !important;\n  border-color: transparent !important;\n}\n.p-button.p-button-text:hover,\n.p-button.p-button-link:hover {\n  background: var(--night-owl-bg-hover) !important;\n  color: var(--night-owl-blue) !important;\n}\n.p-button.p-button-sm {\n  font-size: 0.875rem;\n}\n.p-button.p-button-secondary {\n  background: var(--night-owl-bg-lighter) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-button.p-button-secondary:hover {\n  background: var(--night-owl-bg-hover) !important;\n}\n.p-button:disabled {\n  opacity: 0.5 !important;\n}\n\n/* ── Severity buttons ── */\n.p-button.p-button-danger {\n  background: var(--night-owl-red) !important;\n  border-color: var(--night-owl-red) !important;\n}\n.p-button.p-button-warning {\n  background: var(--night-owl-orange) !important;\n  border-color: var(--night-owl-orange) !important;\n}\n.p-button.p-button-success {\n  background: var(--night-owl-green) !important;\n  border-color: var(--night-owl-green) !important;\n  color: var(--night-owl-bg) !important;\n}\n.p-button.p-button-info {\n  background: var(--night-owl-blue) !important;\n  border-color: var(--night-owl-blue) !important;\n}\n\n/* ── Progress bar ── */\n.p-progressbar {\n  background: var(--night-owl-bg-lighter) !important;\n}\n.p-progressbar .p-progressbar-value {\n  background: var(--night-owl-cyan) !important;\n}\n\n/* ── Badge ── */\n.p-badge.p-badge-danger {\n  background: var(--night-owl-red) !important;\n}\n.p-badge.p-badge-warning {\n  background: var(--night-owl-orange) !important;\n}\n.p-badge.p-badge-info {\n  background: var(--night-owl-blue) !important;\n}\n.p-badge.p-badge-success {\n  background: var(--night-owl-green) !important;\n  color: var(--night-owl-bg) !important;\n}\n\n/* ── Editor panel ── */\n.editor-panel {\n  background: var(--night-owl-bg) !important;\n}\n\n/* ── File picker / breadcrumb ── */\n.p-breadcrumb {\n  background: var(--night-owl-bg-light) !important;\n  border-color: var(--night-owl-border) !important;\n}\n.p-breadcrumb .p-breadcrumb-list li a,\n.p-breadcrumb .p-menuitem-text {\n  color: var(--night-owl-fg) !important;\n}\n.p-breadcrumb .p-breadcrumb-list li a:hover {\n  color: var(--night-owl-cyan) !important;\n}\n\n/* ── Menu / overlay ── */\n.p-menu {\n  background: var(--night-owl-bg-light) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-menu .p-menuitem-link {\n  color: var(--night-owl-fg) !important;\n}\n.p-menu .p-menuitem-link:hover {\n  background: var(--night-owl-bg-hover) !important;\n  color: var(--night-owl-cyan) !important;\n}\n.p-menu .p-menuitem-link .p-menuitem-icon {\n  color: var(--night-owl-fg-muted) !important;\n}\n.p-menu .p-menuitem-link:hover .p-menuitem-icon {\n  color: var(--night-owl-cyan) !important;\n}\n.p-menu .p-menuitem-link .p-menuitem-text {\n  color: var(--night-owl-fg) !important;\n}\n.p-menu .p-menuitem-link:hover .p-menuitem-text {\n  color: var(--night-owl-cyan) !important;\n}\n\n/* ── Overlay panel ── */\n.p-overlaypanel {\n  background: var(--night-owl-bg-light) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n\n/* ── Confirm dialog ── */\n.p-dialog,\n.p-confirm-dialog {\n  background: var(--night-owl-bg-light) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-dialog .p-dialog-header {\n  color: var(--night-owl-fg) !important;\n  background: var(--night-owl-bg-light) !important;\n}\n.p-dialog .p-dialog-footer {\n  background: var(--night-owl-bg-lighter) !important;\n  border-top-color: var(--night-owl-border) !important;\n}\n\n/* ── Toast ── */\n.p-toast .p-toast-message {\n  background: var(--night-owl-bg-lighter) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n\n/* ── Dropdown / select ── */\n.p-dropdown {\n  background: var(--night-owl-bg-lighter) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-dropdown .p-dropdown-label {\n  color: var(--night-owl-fg) !important;\n}\n.p-dropdown:not(.p-disabled):hover {\n  border-color: var(--night-owl-cyan) !important;\n}\n.p-dropdown-panel {\n  background: var(--night-owl-bg-light) !important;\n  border-color: var(--night-owl-border) !important;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n  color: var(--night-owl-fg) !important;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {\n  background: var(--night-owl-bg-hover) !important;\n  color: var(--night-owl-cyan) !important;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n  background: var(--night-owl-selection) !important;\n  color: var(--night-owl-cyan) !important;\n}\n\n/* ── Checkbox / input ── */\n.p-checkbox .p-checkbox-box {\n  background: var(--night-owl-bg-lighter) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-checkbox .p-checkbox-box.p-highlight {\n  background: var(--night-owl-accent) !important;\n  border-color: var(--night-owl-accent) !important;\n  color: #fff !important;\n}\n.p-inputtext {\n  background: var(--night-owl-bg-lighter) !important;\n  border-color: var(--night-owl-border) !important;\n  color: var(--night-owl-fg) !important;\n}\n.p-inputtext:focus {\n  border-color: var(--night-owl-cyan) !important;\n  box-shadow: 0 0 0 0.2rem rgba(33, 199, 216, 0.25) !important;\n}\n\n/* ── Customizer panel ── */\n.customizer-panel {\n  background: var(--night-owl-bg) !important;\n  color: var(--night-owl-fg) !important;\n}\n\n/* ── Log panel ── */\npre {\n  color: var(--night-owl-fg) !important;\n  background: transparent !important;\n}\n\n/* ── Tooltip ── */\n.p-tooltip .p-tooltip-text {\n  background: var(--night-owl-bg-lighter) !important;\n  color: var(--night-owl-fg) !important;\n  border: 1px solid var(--night-owl-border);\n}\n.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--night-owl-bg-lighter) !important;\n}\n\n/* ── Divider / separator ── */\n.p-menu-separator {\n  border-top-color: var(--night-owl-border) !important;\n}\n\n/* ── Link color ── */\na {\n  color: var(--night-owl-cyan);\n}\na:hover {\n  color: var(--night-owl-blue);\n}\n\n/* ── Selection ── */\n::selection {\n  background: var(--night-owl-selection);\n  color: var(--night-owl-fg);\n}\n\n/* ── Monaco editor overrides ── */\n/* Only set the outer container; Monaco's internal elements are canvas/theme-driven */\n.monaco-editor {\n  background-color: #011627 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
